import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SIZES } from '../../../../../src/theme';
import FullScreenLoader from '../../../FullScreenLoader';
import Button, {
  buttonPropTypes,
  BUTTON_OPTIONS,
} from '../../common/atoms/Button';
import useMylocationButtonLogic from './useMyLocationButtonLogic';

const USE_MY_LOCATION_BUTTON_OPTIONS = {
  SIZES,
};

const USE_MY_LOCATION_BUTTON_CONSTS = {
  COLOR: BUTTON_OPTIONS.COLORS.PRIMARY,
  ICON: 'searchArea',
  TEXT: 'Use my location',
  TYPE: 'button',
  VARIANT: BUTTON_OPTIONS.VARIANTS.OUTLINED,
};

const StyledButton = styled(Button)`
  background-color: ${props => props.theme.background.white};
  margin-top: 8px;
`;

const UseMyLocationButton = ({ className, size }) => {
  const { handleClick, loading, ref } = useMylocationButtonLogic();
  return (
    <>
      {loading && <FullScreenLoader />}
      <StyledButton
        className={className}
        color={USE_MY_LOCATION_BUTTON_CONSTS.COLOR}
        handleClick={handleClick}
        icon={USE_MY_LOCATION_BUTTON_CONSTS.ICON}
        ref={ref}
        size={size}
        text={USE_MY_LOCATION_BUTTON_CONSTS.TEXT}
        variant={USE_MY_LOCATION_BUTTON_CONSTS.VARIANT}
      />
    </>
  );
};

const useMyLocationButtonPropTypes = {
  className: buttonPropTypes.className,
  size: PropTypes.oneOf(Object.values(USE_MY_LOCATION_BUTTON_OPTIONS.SIZES)),
};
const useMyLocationButtonDefaultProps = {
  className: undefined,
  size: USE_MY_LOCATION_BUTTON_OPTIONS.SIZES.MD,
};

UseMyLocationButton.propTypes = useMyLocationButtonPropTypes;
UseMyLocationButton.defaultProps = useMyLocationButtonDefaultProps;
export default UseMyLocationButton;
export {
  USE_MY_LOCATION_BUTTON_OPTIONS,
  useMyLocationButtonDefaultProps,
  useMyLocationButtonPropTypes,
};
